import React from 'react';
import { Route, Navigate } from 'react-router-dom';
import ProtectedRoute from '@/modules/auth/ProtectedRoute';

// Lazy-loaded tab containers (Smartketing components — CRM + Landing Pages)
const CrmPage = React.lazy(() => import('@/modules/smartketing/components/CrmPage'));
const DealDetailPage = React.lazy(() => import('@/modules/smartketing/components/DealDetailPage'));

// Sprint 5 — Landing pages (native stratos-growth)
const LandingPagesPage = React.lazy(() => import('@/modules/smartketing/components/LandingPagesPage'));
const LandingPageEditor = React.lazy(() => import('@/modules/smartketing/components/LandingPageEditor'));

// Sprint 11 — Chat inbox (read-only)
const InboxPage = React.lazy(() => import('@/modules/smartketing/components/InboxPage'));

export const ventasRoutes = [
  // CRM (5 tabs: contactos, empresas, pipeline, deals, configuracion)
  <Route key="/ventas/crm" path="/ventas/crm" element={
    <Navigate to="/ventas/crm/contactos" replace />
  } />,
  <Route key="/ventas/crm/contactos" path="/ventas/crm/contactos" element={
    <ProtectedRoute requiredPermission="smarketing.contacts.view"><CrmPage /></ProtectedRoute>
  } />,
  <Route key="/ventas/crm/empresas" path="/ventas/crm/empresas" element={
    <ProtectedRoute requiredPermission="smarketing.companies.view"><CrmPage /></ProtectedRoute>
  } />,
  <Route key="/ventas/crm/pipeline" path="/ventas/crm/pipeline" element={
    <ProtectedRoute requiredPermission="smarketing.deals.view"><CrmPage /></ProtectedRoute>
  } />,
  <Route key="/ventas/crm/deals" path="/ventas/crm/deals" element={
    <ProtectedRoute requiredPermission="smarketing.deals.view"><CrmPage /></ProtectedRoute>
  } />,
  <Route key="/ventas/crm/configuracion" path="/ventas/crm/configuracion" element={
    <ProtectedRoute requiredPermission="smarketing.deals.view"><CrmPage /></ProtectedRoute>
  } />,
  <Route key="/ventas/crm/deals/:dealId" path="/ventas/crm/deals/:dealId" element={
    <ProtectedRoute requiredPermission="smarketing.deals.view"><DealDetailPage /></ProtectedRoute>
  } />,

  // Landing Pages (Sprint 5 — stratos-growth native)
  <Route key="/ventas/landing-pages" path="/ventas/landing-pages" element={
    <ProtectedRoute requiredPermission="smarketing.contacts.view"><LandingPagesPage /></ProtectedRoute>
  } />,
  <Route key="/ventas/landing-pages/new" path="/ventas/landing-pages/new" element={
    <ProtectedRoute requiredPermission="smarketing.contacts.view"><LandingPageEditor /></ProtectedRoute>
  } />,
  <Route key="/ventas/landing-pages/:id/edit" path="/ventas/landing-pages/:id/edit" element={
    <ProtectedRoute requiredPermission="smarketing.contacts.view"><LandingPageEditor /></ProtectedRoute>
  } />,

  // Sprint 11 — Chat inbox (read-only, human reply in Sprint 25)
  <Route key="/ventas/inbox" path="/ventas/inbox" element={
    <ProtectedRoute requiredPermission="smarketing.contacts.view"><InboxPage /></ProtectedRoute>
  } />,
];
